<tg-row>
  <tg-col>
    <div class="show-more-text-field-text-container"
      [ngClass]="{ 'show-more-text-field-text-container--max-height': (showAll$ | async) === false }">
      <span #descriptionElement class="show-more-text-field-value show-more-text-field-text">{{ displayText }}</span>
      <div class="show-more-text-field-text-ellipsis"
        [ngClass]="{'show-more-text-field-text-ellipsis--visible': (showAll$ | async) === false}">
        ...
      </div>
    </div>
  </tg-col>
</tg-row>
@if (isMoreThanMaxLines$ | async) {
  <tg-row>
    <tg-col>
      <button tgButton2 linkStyle (click)="onShowMore()">
        {{ (showAll$ | async) === false ? 'show more' : 'show less' }}
        @if ((showAll$ | async) === false) {
          <tg-icon-right size="small" name="basic-plus" alt="show more"></tg-icon-right>
        }
        @if (showAll$ | async) {
          <tg-icon-right size="small" name="basic-minus" alt="show less"></tg-icon-right>
        }
      </button>
      <br />
      <br />
    </tg-col>
  </tg-row>
}